import Main from "./containers/Main";

import { YMInitializer } from "react-yandex-metrika"
// import ym from "react-yandex-metrika";

const { MODE } = import.meta.env;

const Root = () => {
    return (
        <>
            <YMInitializer
                accounts={MODE === 'production' ? [103353448] : []}
                version='2'
                options={{
                    clickmap: true,
                    trackLinks: true,
                    accurateTrackBounce: true,
                    webvisor: true,
                    trackHash: true,
                }}
            />
            <Main />
        </>
    );
};

export default Root;
